import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function ChevronThinPrev(props) {
    return (
        <SvgIcon {...props}>
            <path d="M23 43L1.48781 22.5122L23 1" stroke="#F2F2F2" strokeWidth="2" />
        </SvgIcon>
    );
}

ChevronThinPrev.defaultProps = {
    viewBox: '0 0 24 44',
    fill: 'transparent',
};

export default ChevronThinPrev;
